import React from 'react';
import { LegalDocPage } from './LegalDocPage';

export const PrivacyPage: React.FC = () => {
  return (
    <LegalDocPage
      docId="privacy"
      title="Privacy Policy"
      updatedAt="January 13, 2026"
    />
  );
};
